import { Star } from "lucide-react";

export const Logo = () => {
  return (
    <div className="flex items-center space-x-2">
      <div className="w-8 h-8 bg-gradient-to-r from-cosmic-gold to-cosmic-glow rounded-full flex items-center justify-center">
        <Star className="w-5 h-5 text-primary-foreground" />
      </div>
      <span className="text-2xl font-bold text-cosmic-gold">Life Journey Report</span>
    </div>
  );
};
